export default __webpack_public_path__ + "static/media/DrMGBhatt.3a54c005.png";